/* eslint-disable react/prop-types */
import React from 'react';
import Amount from 'components/Amount';
import InfoHoverBlock from 'components/success/InfoHoverBlock';
import dataMPRcolors from 'data/dataMPRcolors';
import { normalizeAmount } from 'utils/normalizeAmount';

class PrimeBlock extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      //   showPicker: false
    };
  }

  render() {
    const MaPrimeRenov = normalizeAmount(
      this.props.APIresult['Montant MPR unitaire (€)'],
    );
    const PrimeHellio = normalizeAmount(
      this.props.APIresult['Montant prime CEE unitaire (€)'],
    );
    const PrimeMax = normalizeAmount(
      this.props.APIresult['Montant max prime (€)'],
    );
    const sign = this.props.positive ? '' : '- ';

    return (
      <>
        {PrimeMax !== 0 && (
          <div className="success-item-right !pb-4">
            <div>
              <InfoHoverBlock
                data={this.props.APIresult}
                success={this.props.success}
                item="PrimeMax"
                showTooltip
              />
            </div>
            <div>
              <h5 className="h5-prime whitespace-nowrap">
                {sign}
                <Amount value={PrimeMax} />
              </h5>
            </div>
          </div>
        )}

        {PrimeHellio !== 0 && (
          <div
            className={
              MaPrimeRenov || this.props.resultCodePromo?.data?.montant_promo
                ? 'success-item-right no-border'
                : 'success-item-right'
            }
          >
            <div>
              <InfoHoverBlock
                data={this.props.APIresult}
                success={this.props.success}
                item="Prime1"
                showTooltip
              ></InfoHoverBlock>
            </div>
            <div>
              <h5 className="h5-prime whitespace-nowrap">
                {sign}
                <Amount value={PrimeHellio} />
              </h5>
            </div>
          </div>
        )}

        {MaPrimeRenov !== 0 && (
          <div className="success-item-right">
            <div>
              <InfoHoverBlock
                data={this.props.APIresult}
                success={this.props.success}
                item="Prime2"
                showTooltip
              ></InfoHoverBlock>
            </div>
            <div>
              <h5
                className="h5-prime whitespace-nowrap"
                style={{
                  backgroundColor:
                    dataMPRcolors[this.props.APIresult['Couleur MPR']]?.bg,
                }}
              >
                {sign}
                <Amount value={MaPrimeRenov} />
              </h5>
            </div>
          </div>
        )}

        {this.props.resultCodePromo?.data?.montant_promo && (
          <div className="success-item-right">
            <div className="info-block-container">
              <p className="is-bold fz22">Code Promo</p>
            </div>
            <div>
              <h5 className="h5-prime whitespace-nowrap">
                {sign}
                <Amount value={this.props.resultCodePromo.data.montant_promo} />
              </h5>
            </div>
          </div>
        )}
      </>
    );
  }
}

export default PrimeBlock;
